import React, { Component } from 'react';
import {getProducts, fetchData} from '../../../repository';



let product_attributes = [];

class Products extends Component {
    constructor(props) {
        super(props);
        this.state = {
            temp_products_detail: []
        };                
    }

    componentDidMount() {     
        this.query_products();
        
    }

    componentDidUpdate(prevProps, prevState) {
        
        if (this.props.products !== prevProps.products) {
            // console.log(`passed on products`, this.props.products);
            this.query_products_detail();            
        }

        if (this.props.products_detail_temp !== prevProps.products_detail_temp && this.props.products_detail_temp.length === this.props.products.length){
            // console.log(`Props 1: `, this.props)
            this.init_products_meta_details();
        }

        if (this.props.products_detail !== prevProps.products_detail){
            this.query_products_extra();
        }

        if (this.props.children_products_detail !== prevProps.children_products_detail){
            // console.log(`child products detail`, this.props.children_products_detail);
        }

        if (this.props.default_products !== prevProps.default_products && this.props.default_products.length === this.props.products.length) {
            // console.log(`Props 2: `, this.props)            
            this.create_current_default_product();            
        }    
        
        if (this.props.new_current_product !== prevProps.new_current_product) {
            // console.log(`Props 3: `, this.props)            
        }
        
    }
    
    query_products = () => {
        getProducts()

        .then((data) => {                        
           this.props.init_products(data);
        })        
        // console.log(`Products`, products);
    } 

    query_products_detail = () => {        
        let i=0;
        let products_data = this.props.products;
        let product_detail = [];
        let result;        
        let product_attribute;
        let product_attributes = [];
        let item_category;

        for (i=0; i < products_data.length; i++) {                
            // console.log(`Product Url: `, products_data[i].url);
            // console.log(`Product Title: `, products_data[i].title);
            fetchData( products_data[i].url )

            .then( (data) => {                
                this.props.init_products_details_temp(data);
                // console.log(`Data: `, data);
                // this.state.temp_products_detail.concat(data);
            });            

            if (products_data[i].title === "Essential Medium") {
                item_category = 'cocoon-essential';
            } else if (products_data[i].title === "Cocoon Classic") {
                item_category = 'cocoon-classic';
            } else if (products_data[i].title.match(/Sealy Premium/g) ) {
                item_category = 'sealy-premium';
            } else if (products_data[i].title.match(/Sealy Performance/g) ) {
                item_category = 'sealy-performance';
            } else if (products_data[i].title.match(/Sealy Essential/g) ) {
                item_category = 'sealy-essential';
            }  
                        
            product_attribute = {
                category: item_category,                
                parent_id: products_data[i].id 
            }

            product_attributes = product_attributes.concat(product_attribute);  
        }        
        
        this.props.init_product_meta(product_attributes);

        //     let data = this.state.child_products
        // let i=0;
        // for (i=0; i < data.length; i++) {
        //     // console.log(`Count .... ${i}`);
        //     this.getProductSku(data[i].sku_url, data[i].id, i);
        //     this.getProductPrice(data[i].price_url, data[i].id, i);
        //     this.getProductAvailabiliy(data[i].availability_url, data[i].id, i);
        // }
    }    

    init_products_meta_details = () => {
        // console.log(`temp products detail`, this.props.products_detail_temp);
        this.props.init_products_details(this.props.products_detail_temp);        
    }

    query_products_extra = () => {
        const products = this.props.products_detail;
        let default_products=[];
        let product_options=[];
        let default_product_item, options;
        let product_data;
        // console.log(`Products Detail`, products);
        let i=0;
        for (i=0; i < products.length; i++) {
            // console.log(`Defalt Products are now: ${i} - `, this.props.default_products);
            if (products[i].structure === 'standalone') {
                default_product_item = {id:products[i].id, parent: ''}                
                // this.props.set_default_products(default_product_item);
                // get product price, sku, and availability
                this.get_product_price(products[i].id, products[i].price);
                this.get_product_sku(products[i].id, products[i].stockrecords);
                this.get_product_availability(products[i].id, products[i].availability)
            }else{
                // add child products
                // console.log(`Add child Products`, products[i].children);
                product_data = this.add_child_products(products[i].children, products[i].product_class, products[i].id);
                // console.log(`Product data`, product_data);
                default_product_item = product_data.default_product_item;
                options = product_data.options;
                product_options = product_options.concat(options);                
            }
            

            default_products = default_products.concat(default_product_item);            
        }        

        // console.log(`Building default products`, default_products);

        
        this.props.set_product_options(product_options);
        this.props.set_default_products(default_products);
    }

    add_child_products = (children, category, parent_id) => {
        let i=0;
        let size;
        let comfort;        
        let default_product;
        let default_product_item, item_category;
        let product_options=[];
        let data;
        let options;
        for (i=0; i < children.length; i++) {
            // children[i].title
            data = {id: category, product: children[i]}
            this.props.set_child_products(data);
            this.get_children_product_detail(children[i]);
            if (category === "mattress") {
                // set product options
                size = this.props.match_mattress_size(children[i].title);
                comfort = this.props.match_mattress_comfort(children[i].title);
                default_product = this.props.set_default_product(children[i].title);
                if (default_product === true){
                    default_product_item = {id:children[i].id, parent: parent_id}                    
                }

                if (children[i].title.match(/Essential Medium/g)) {
                    item_category = 'cocoon-essential';
                } else if (children[i].title.match(/Cocoon Classic/g)) {
                    item_category = 'cocoon-classic';
                }

                options = {id: children[i].id, size: size, comfort: comfort, category: item_category};    
                product_options = product_options.concat(options);                                            
                // store default product
            }
        }
        
        return {default_product_item:default_product_item, options:product_options};
    }

    create_current_default_product = () =>{
        const page_category = document.getElementsByClassName('hero hero--chill')[0].dataset.productCategory;                                
        let metadata;
        let default_product;
        let def_product, current_product;
        // retrieve parent_products_meta_data from category   
        metadata = this.get_product_meta_data(page_category);
        // console.log(`Metadata: `, metadata[0]);
        const default_products  = this.props.default_products;
        // console.log(`Default products are: `, default_products);        

        if (metadata[0].category !== 'cocoon-classic' && metadata[0].category !== 'cocoon-essential') {
            def_product = metadata[0].parent_id;
            current_product = {id: def_product, parent_id: 0};
        }else{
            def_product = default_products.filter(item => item.parent === metadata[0].parent_id);
            current_product = {id: def_product[0].id, parent_id: def_product[0].parent};
        }        

        // console.log(`Default product is: `, def_product);        
        // console.log(`Current product is: `, current_product);   
        
        this.props.set_new_current_product(current_product);

        // if (page_category === "cocoon-classic") {
                     
        //     const def_product = default_products.filter(item => item.parent === metadata.parent_id);
        //     // def_product = def_product.filter(item => item.category === 'cocoon-classic');            
                                                        
        // }else if (page_category === "cocoon-essential") {  
        //     // console.log(`page Category 2: ${page_category}`);          
        //     // def_product = data.filter(item => item.default === true);
        //     // def_product = def_product.filter(item => item.category === 'cocoon-essential');
        //     // console.log(def_product);
        // }                
    }

    get_product_meta_data = (category) => {
        const data=this.props.parent_products_meta_data;
        // console.log(`category ${category} data`, data);
        const attributes = data.filter(item => item.category === category);
        return attributes;
    }

    get_product_price = (id, url) => {
        
        fetchData(url).then( (response) => {             
            // console.log(`Response Price: `, response);    
            this.props.set_product_price(response, id);                        
        });
        
    }

    get_product_sku = (id, url) => {
        fetchData(url).then( (response) => {       
            // console.log(`Response SKU: `, response);
            this.props.set_product_sku(response[0].partner_sku, id);
        });        
    }

    get_product_availability = (id, url) => {
        fetchData(url).then( (response) => {        
            // console.log(`Response Availability: `, response);    
            this.props.set_product_availability(response, id);                        
        });     
    }

    get_children_product_detail = (products) => {        
        // console.log(`Add child Products Detail`, products);
                
        // console.log(`Products ULR: `, products.url);  
        fetchData(products.url).then( (response) => {
            // console.log(`Response Product: `, response);  
            this.props.set_child_products_detail(response);
            this.get_product_price(response.id, response.price);
            this.get_product_sku(response.id, response.stockrecords);
            this.get_product_availability(response.id, response.availability);
        });
                
    }


    render() {        
        return(
            <React.Fragment></React.Fragment>
        );
    }
}

export default Products;